import type React from 'react';

import { MOUTH_STATUS_OPTIONS } from '@vlabs/api-bindings/src/constants';
import type { MouthAttributes as SDKMouthAttributes } from '@vlabs/api/luna-api/model';

interface MouthValueProps {
  mouthAttributes?: SDKMouthAttributes;
}

function MouthValue({
  mouthAttributes = undefined,
}: MouthValueProps): React.ReactNode {
  const { score, ...attribute } = mouthAttributes ?? {};

  const [predominantState, predominantScore] = Object
    .entries(attribute)
    .sort((attr1, attr2) => attr2[1] - attr1[1])[0]
    ?? [];

  if (!predominantState || !predominantScore) return '-';

  return (
    // @ts-expect-error MOUTH_STATUS_OPTIONS — proxy
    <div>{`${MOUTH_STATUS_OPTIONS[predominantState].label} (${predominantScore.toFixed(5)})`}</div>
  );
}

export { MouthValue };
